module.exports = __webpack_public_path__ + "img/hourglass_3.90a538e8.svg";